"use client";

import { PrivyProvider } from "@privy-io/react-auth";

const privyAppId =
  process.env.NEXT_PUBLIC_PRIVY_APP_ID ??
  "cmtn6zcz200jt0ciet17ro3sg";

export default function Providers({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <PrivyProvider
      appId={privyAppId}
      config={{
        loginMethods: [
          "email",
          "google",
        ],
        embeddedWallets: {
          ethereum: {
            createOnLogin: "users-without-wallets",
          },
        },
        appearance: {
          theme: "light",
        },
      }}
    >
      {children}
    </PrivyProvider>
  );
}